export const GRADE_ROW_HEIGHT = 56;
export const SCHOOL_ROW_HEIGHT = 48;
export const ALL_SCHOOLS_KEY = "ALL_SCHOOLS";
export const INTERSECTION_THRESHOLD = 0.1;
export const ROOT_MARGIN = "50px";
export const DEBOUNCE_MS = 300;
export const SKELETON_ROW_COUNT = 5;

export const USER_TYPE_COUNT_FIELDS = {
  STAFF: "staffCount",
  STUDENT: "studentCount",
  FAMILY_MEMBER: "familyMemberCount",
};

export const PARTICIPANT_USER_TYPES = {
  STAFF: "common:staff_member",
  STUDENT: "common:student",
  FAMILY_MEMBER: "common:family_member",
};
